import { ServicesGroup } from "utils/helpers/ServicesGroup"

export function getIsBookingAvailable(serviceGroups: ServicesGroup[]) {
    return serviceGroups.some((serviceGroup) => serviceGroup?.availableStatusWithCompany.ok)
}
